export default __webpack_public_path__ + "static/media/image3.c6a0690a.png";